import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators';
import { Action } from 'redux';
import { SetActiveProfile, SetUserToActiveProfile } from '../action-creators';
import { SET_USER_TO_ACTIVE_PROFILE } from '@webapp/store/active-profile/actions';

export const setUserToActiveProfileEpic = (action$: Observable<Action>) =>
  action$.pipe(
    ofType<Action, SetUserToActiveProfile>(SET_USER_TO_ACTIVE_PROFILE),
    map((action) => {
      new SetActiveProfile(false, action.user.id as string);
    })
  );
